<template>
  <DBox :id="'cmp-licencing-licence_accounts-account_setup'" :addButton="false">
    <div class="ut-fc">
      <TextField2
        style="flex: 1"
        id="account_name"
        :placeholder="$t('account_name')"
        :label="$t('account_name')"
        :value="selectedAccountsDetails.account.account_name"
        @blur="(e) => onTextFieldValueChange(e)"
      />

      <TextField2
        style="flex: 1"
        id="account_type"
        :placeholder="$dft.capHead($t('account_type'))"
        :label="$dft.capHead($t('account_type'))"
        :value="selectedAccountsDetails.account.account_type"
        @blur="(e) => onTextFieldValueChange(e)"
      />
      <!-- <TextField2
            
              id="keyword"
              class="m1"
              :placeholder="$dft.capHead('keyword')"
              :label="$dft.capHead('keyword')"
              :value="selectedAccountsDetails.account.keyword"
            
              @blur=" e => onTextFieldValueChange(e) "
          /> -->

      <Dropdown2
        style="flex: 1"
        id="invoice_project_id"
        :label="$dft.capHead($t('invoice_project1'))"
        :placeholder="'Select ' + $dft.capHead($t('invoice_project1'))"
        :disabled="false"
        :options="invoiceProjectsTV"
        :selected="
          invoiceProjectsTV.find(
            (e) => e.value == selectedAccountsDetails.account.invoice_project_id
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
      />
      <Dropdown2
        style="flex: 1"
        id="user_id"
        :label="$dft.capHead($t('staff_org'))"
        :placeholder="'Select ' + $dft.capHead($t('staff_org'))"
        :disabled="false"
        :options="userTV"
        :selected="
          userTV.find((e) => e.value == selectedAccountsDetails.account.user_id)
        "
        v-on:selectedChange="(e) => onDropdownChange('user_id', e)"
      />
      <Dropdown2
        style="flex: 1"
        id="status_id"
        :label="$dft.capHead($t('status'))"
        :placeholder="'Select ' + $dft.capHead($t('status'))"
        :disabled="false"
        :options="statusTV"
        :selected="
          statusTV.find(
            (e) => e.value == selectedAccountsDetails.account.status_id
          )
        "
        status
        v-on:selectedChange="(e) => onDropdownChange('status_id', e)"
      />

      <Checkbox2
        style="flex: 1"
        :disabled="false"
        :id="'digital'"
        :label="$dft.capHead($t('digital'))"
        :value="selectedAccountsDetails.account.digital"
        :placeholder="$dft.capHead($t('digital'))"
        @input="onCheckboxChange"
      />

      <Checkbox2
        style="flex: 1"
        :disabled="false"
        :id="'physical'"
        :label="$dft.capHead($t('physical'))"
        :value="selectedAccountsDetails.account.physical"
        :placeholder="$dft.capHead($t('physical'))"
        @input="onCheckboxChange"
      />

      <Dropdown2
        style="flex: 1"
        id="currency_id"
        :label="$dft.capHead($t('currency'))"
        :placeholder="'Select ' + $dft.capHead($t('currency'))"
        :disabled="false"
        :options="currencyTV"
        :selected="
          currencyTV.find(
            (e) => e.value == selectedAccountsDetails.account.currency_id
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('currency_id', e)"
      />
      <TextField2
        style="flex: 1"
        id="short_name"
        :placeholder="$dft.capHead($t('short'))"
        :label="$dft.capHead($t('short'))"
        :value="selectedAccountsDetails.account.short_name"
        @blur="(e) => onTextFieldValueChange(e)"
      />
      <TextField2
        style="flex: 1"
        id="credit_limit"
        :placeholder="$dft.capHead($t('line_of_credit'))"
        :label="$dft.capHead($t('line_of_credit'))"
        :value="selectedAccountsDetails.account.credit_limit"
        :bb="'0px'"
        @blur="(e) => onTextFieldValueChange(e)"
      />
    </div>
  </DBox>
</template>
<script>
import { createTV, tv } from "../../../../models/text-value.model";

export default {
  props: {
    selectedAccountsDetails: {
      type: Object,
    },
    statusTV: {
      type: Array,
    },
  },

  data: () => ({
    textFieldConfig: {
      height: 42,
      showEditIconOnHover: false,
      box: true,
      showValidationIcons: true,
    },
    licence_account_name: "",
    keyword: "",
    business_status: "",
  }),
  methods: {
    onTextFieldValueChange: function (e) {
      const payload = {
        name: e.name,
        value: e.value,
      };
      this.$emit("changed", payload);
    },
    onCheckboxChange: function ({ name, value }) {
      this.$emit("changed", {
        name,
        value: value ? "1" : "0",
      });
    },
    onDropdownChange: function (name, e) {
      const payload = {
        name: name,
        value: e.value,
      };
      this.$emit("changed", payload);
      //console.log("WERERTYUPOIUN",payload)
    },
  },
  computed: {
    invoiceProjectsTV: function () {
      return createTV(
        this.selectedAccountsDetails?.invoice_projects,
        "invoice_project_name",
        "invoice_project_id"
      );
    },
    userTV: function () {
      return createTV(
        this.selectedAccountsDetails?.users,
        "user_name",
        "user_id"
      );
    },

    currencyTV: function () {
      return createTV(
        this.selectedAccountsDetails?.currencies,
        "currency_iso",
        "currency_id"
      );
    },
  },
};
</script>
<style lang="scss">
.cmp-licencing-licence-accounts-sidewindow-account_setup {
  .flex-container {
    display: flex;
    padding: 10px;
    .flex-item {
      flex: 0.25;
      padding: 10px;
    }
  }
}
</style>
